import React from "react";
import AdminLayout from "../components/AdminLayout";

function Usuarios() {
  return (
    <AdminLayout>
      <div className="page-header d-print-none">
        <div className="row align-items-center">
          <div className="col">
            <h2 className="page-title">Usuários</h2>
          </div>
        </div>
      </div>
      {/* Conteúdo da página de usuários */}
    </AdminLayout>
  );
}

export default Usuarios;